import { Component, OnDestroy, OnInit } from '@angular/core';
import { PostDO } from '../common/data-objects/PostDO';
import { Subscription } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { Meta, Title } from '@angular/platform-browser';
import { Angulartics2 } from 'angulartics2';
import { ActivatedRoute, Router } from '@angular/router';
import { SeoService } from '../common/services/seo.service';
import { PostsService } from '../common/services/posts.service';
import urlSlug from 'url-slug';
import { IPageChangeData } from '../common/data-objects/IPageChangeData';

@Component({
  selector: 'app-crafts-page',
  templateUrl: './crafts-page.component.html',
  styleUrls: ['./crafts-page.component.scss']
})
export class CraftsPageComponent implements OnInit, OnDestroy {
  posts: PostDO[];
  page: number;
  itemsCount: number;
  isLoading = true;
  pagesCount: number;
  private getDataSubscription: Subscription;

  constructor(
    private toastr: ToastrService,
    private titleService: Title,
    private angulartics2: Angulartics2,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private meta: Meta,
    private seoService: SeoService,
    private postsService: PostsService
  ) {
    this.seoService.setTitle('Lucru manual biblic - Fun Bible');
    this.seoService.setDescription('Peste 100 de activitati de lucru manual');
    this.meta.updateTag({ property: 'og:url', content: 'https://funbible.net/crafts/' });
    this.meta.updateTag({ property: 'og:image', content: 'https://funbible.net/assets/tv.jpg' });
    const initialKeywords = ['lucru manual biblic', 'lucru manual crestin', 'craft biblic', 'craft crestin'].join();
    this.meta.updateTag({property: 'keywords', content: initialKeywords});
    this.angulartics2.eventTrack.next({
      action: 'crafts',
      properties: { category: 'pageView' },
    });
  }

  ngOnInit() {
  }

  ngOnDestroy() {
    if (this.getDataSubscription) {
      this.getDataSubscription.unsubscribe();
    }
  }

  getData({searchText, page}: IPageChangeData) {
    this.isLoading = true;
    this.getDataSubscription = this.postsService.getCraftPages(searchText, page).subscribe((postsData) => {
      this.posts = postsData.posts;
      this.pagesCount = postsData.pagesCount;
      this.itemsCount = postsData.itemsCount;
      this.isLoading = false;
    }, () => {
      this.toastr.error('Acest conținut nu s-a putut încărca!');
      this.isLoading = false;
    });
  }
}
